import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { renderIf } from 'modules/render-if';
import classes from '../shared.scss';
import classNames from 'classnames';
import ValidationMessage from 'shared-components/FormFields/ValidationMessage';
import Tooltip from 'shared-components/ToolTip';

class Checkbox extends Component {
  onChange = (e) => {
    const handler = this.props.onChange;
    if (handler) handler(e, e.target.checked);
  }

  render() {
    const {
      label,
      className,
      valid,
      error,
      tooltip
    } = this.props;

    const fieldClass = classNames({
      [classes.field]: true,
      [className]: typeof className === 'string',
    });

    const inputClass = classNames({
      [classes.error]: valid === false,
      [classes.checkbox]: true,
    });
    const inputProps = {
      ...this.props.input,
      className: inputClass,
      onChange: this.onChange,
      type: 'checkbox',
    };

    return (
      <div className={ fieldClass }>
        <label>
          <input { ...inputProps } />
          <span>{ label }</span>
          { renderIf(!!tooltip)(() => {
            const props = { ...tooltip, className: classes['checkbox-tooltip'] };
            return <Tooltip { ...props } />;
          }) }
          <ValidationMessage message={ error } />
        </label>
      </div>
    );
  }
}

Checkbox.propTypes = {
  className: PropTypes.string,
  error: PropTypes.string,
  input: PropTypes.shape({
    name: PropTypes.string.isRequired,
  }).isRequired,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  tooltip: PropTypes.shape({
    title: PropTypes.string,
    content: PropTypes.string,
  }),
  valid: PropTypes.bool,
};

export default Checkbox;
